require('./bootstrap');

const {SigmaChat} = require('./sigma-chat-v2-sdk');
window.SigmaChat = SigmaChat

